import axios from 'axios';
import { BUSINESS_API_BASE_URL } from './endpoint';

export const getServiceCategories = async (businessId) => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/services/categories/`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data.items
}

export const getServices = async (businessId) => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/services/`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data.items
}

export const getServiceById = async (businessId,serviceId) => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/services/${serviceId}`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data
}
